import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
type Crumb = {
  label: string;
  to?: string;
};
type PageHeroProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  crumbs?: Crumb[];
  image?: string;
};
export function PageHero({
  eyebrow,
  title,
  description,
  crumbs,
  image
}: PageHeroProps) {
  return <section className="relative overflow-hidden bg-ink" data-id="element-198" data-mp="25bzip181hl4">
      {image && <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-20" data-id="element-199" data-mp="ptv7t4k9tud7" />}
      <div className="relative mx-auto max-w-7xl px-6 py-12 md:py-16" data-id="element-200" data-mp="g2ih4ga7la8r">
        {crumbs && crumbs.length > 0 && <nav aria-label="Breadcrumb" className="mb-4" data-id="element-201" data-mp="l0saclcdi0rq">
            <ol className="flex flex-wrap items-center gap-1 text-xs font-semibold uppercase tracking-widest text-steel-400" data-id="element-202" data-mp="18rfqtv0ctypw">
              {crumbs.map((c, i) => <li key={c.label} className="flex items-center gap-1" data-id="element-203" data-mp="1dkimc8oozi8q" data-mpi={i}>
                  {c.to ? <Link to={c.to} className="hover:text-safety" data-id="element-204" data-mp="32fzhriskzk7h">
                      {c.label}
                    </Link> : <span className="text-steel-200" data-id="element-205" data-mp="3c8x1fs9b7f7o">{c.label}</span>}
                  {i < crumbs.length - 1 && <ChevronRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-206" data-mp="37fc13tk8u95b" />}
                </li>)}
            </ol>
          </nav>}
        {eyebrow && <p className="mb-2 text-sm font-bold uppercase tracking-[0.2em] text-safety" data-id="element-207" data-mp="3gbtc8wsly712">
            {eyebrow}
          </p>}
        <h1 className="max-w-3xl font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-white md:text-5xl" data-id="element-208" data-mp="3q7d6zfvfqzo8">
          {title}
        </h1>
        {description && <p className="mt-4 max-w-2xl text-base leading-relaxed text-steel-200 md:text-lg" data-id="element-209" data-mp="1vu57hawilzw9">
            {description}
          </p>}
      </div>
    </section>;
}